// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import TabPage from "./../../../factories/tab-page";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
import AppTabController from "./../../../services/app-tab-controller";

function UserRoleTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.User = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.PageSize.subscribe(function () {
        if (self.PageIndex() === 0) {
            self.RefreshGrid();
        }
        else {
            self.PageIndex(0);
        }
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.RoleCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteUserRole");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "UserRoleAdd":
                self.ShowUserRoleDialog();
                break;
            case "UserRoleEdit":
                if (self.SelectedRoleRow() != null) {
                    self.ShowRoleTab(self.SelectedRoleRow());
                }
                break;
            case "UserRoleDelete":
                if (self.SelectedRoleRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteUserRole(self.SelectedRoleRow().OpenData);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedRoleId = ko.observable();
    self.SelectedRole = ko.observable();
    self.SelectedRole.subscribe(function () {
        self.AddUserRole(self.SelectedRoleId(), self.User.UserId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/UserTab/GetUserRoleCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedRoleRow(null);
            self.TotalRows(0);
            self.RoleCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.RoleCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddUserRole = function (roleId, userId) {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/UserTab/AddUserRole", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: userId,
            roleId: roleId
        }), function (serverResult) {
            if (serverResult.Result) {
                self.User.TabPage.DirtyFlag(true);
                self.RefreshGrid();
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, serverResult.Message, "info");
                tabPage.IsLoading(false);
            }
        });
    };
    self.DeleteUserRole = function (roleUserId) {
        return Bao.post("Uadm/UserTab/DeleteUserRole", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            roleUserId: roleUserId
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowRoleTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("Uadm/Role");
            newTab.UrlData({
                id: item.RoleId
            });
            newTab.ObjectId(item.RoleId);
            AppTabController.AddTab(newTab);
        }
    };
    self.ShowUserRoleDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedRoleRow = ko.observable({});
    self.SelectedRoleRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "UserRoleEdit":
                case "UserRoleDelete":
                    button.Enabled(!(self.SelectedRoleRow() == null));
                    break;
                case "UserRoleAdd":
                    button.Enabled(!self.User.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/UserTab/ResetUserRole", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("Uadm/UserTab/SaveUserRoleCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Copy = function (userId, saveTime) {
        return Bao.post("Uadm/UserTab/CopyUserRoleCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            newUserId: userId,
            saveTime: saveTime
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
}
;
export default UserRoleTabModel;